import type { ReactNode } from 'react'
import { create } from 'zustand'

export interface OverlayEntry {
  id: number
  render: () => ReactNode
}

interface OverlayState {
  entries: OverlayEntry[]
  /** Mounts an overlay; the promise resolves with whatever the overlay passes to `close`. */
  push: (render: (close: (result: unknown) => void) => ReactNode) => Promise<unknown>
  remove: (id: number) => void
}

let nextId = 1

export const useOverlayStore = create<OverlayState>((set, get) => ({
  entries: [],
  push: (render) =>
    new Promise((resolve) => {
      const id = nextId++
      const close = (result: unknown) => {
        get().remove(id)
        resolve(result)
      }
      set({ entries: [...get().entries, { id, render: () => render(close) }] })
    }),
  remove: (id) => set({ entries: get().entries.filter((e) => e.id !== id) }),
}))
